/* Lotus Wheel "the solution" — on scroll the lines draw in, "Stop renting it."
   fades to 50%, then the arrow + "Start owning it." appear. CSS owns the
   sequence; this just toggles the class. Progressive enhancement (final
   state already correct without JS); skipped for reduced motion. */
class SolutionReveal extends HTMLElement {
  connectedCallback() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    this.classList.add('is-armed');
    this.observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((e) => e.isIntersecting)) {
          this.classList.add('is-revealed');
          this.observer.disconnect();
        }
      },
      { threshold: 0.35 }
    );
    this.observer.observe(this);
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }
}

customElements.define('solution-reveal', SolutionReveal);
